var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSg = function SvgSg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 14"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 11.857,
    x: 0.5,
    y: 1.071,
    fill: "#fff",
    stroke: "#F5F5F5",
    rx: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "SG_svg__a",
    width: 18,
    height: 14,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 11.857,
    x: 0.5,
    y: 1.071,
    fill: "#fff",
    stroke: "#fff",
    rx: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#SG_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E12237",
    d: "M0 7.429h18V.57H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.143 1.857c.263 0 .516.048.749.135a2.571 2.571 0 1 0 0 4.017 2.143 2.143 0 1 1-.749-4.151M4.714 4a.429.429 0 1 0 0-.857.429.429 0 0 0 0 .857M6 5.286a.429.429 0 1 1-.857 0 .429.429 0 0 1 .857 0m1.286.428a.429.429 0 1 0 0-.857.429.429 0 0 0 0 .857M8.57 3.571a.429.429 0 1 1-.857 0 .429.429 0 0 1 .857 0M6.43 2.714a.429.429 0 1 0 0-.857.429.429 0 0 0 0 .857"
  }))));
};
export default SvgSg;